import useSearchParams from "hooks/useSearchParams";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

const useInstitutionsFilters = () => {
	const [firstPage, setFirstPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [page, setPage] = useState(1);
	const [searchTerm, setSearchTerm] = useState("");

	const { getParam, setParam, deleteParam, hasParam } = useSearchParams();
	const { push } = useHistory();
	const { pathname } = useLocation();

	useEffect(() => {
		if (hasParam("page")) {
			const pageParam = getParam("page")?.length > 0 ? getParam("page") : 1;
			setPage(pageParam);
		}

		if (hasParam("rows")) {
			const rowsPerPageParam =
				getParam("rows")?.length > 0 ? getParam("rows") : 10;
			setRowsPerPage(rowsPerPageParam);
		}

		if (hasParam("first_page")) {
			const firstPageParam =
				getParam("first_page")?.length > 0 ? getParam("first_page") : 0;
			setFirstPage(firstPageParam);
		}

		if (hasParam("search")) {
			const searchTermParam =
				getParam("search")?.length > 0 ? getParam("search") : "";
			setSearchTerm(searchTermParam);
		}

		return () => {
			deleteParam("page");
			deleteParam("rows");
			deleteParam("first_page");
			deleteParam("search");
		};
	}, [hasParam, getParam, deleteParam]);

	const changePage = (value) => {
		if (value?.length <= 0) {
			const q = deleteParam("page");
			setPage(1);
			return push(`${pathname}?${q}`);
		}
		const q = setParam("page", value);
		push(`${pathname}?${q}`);
	};

	const changeRowsPerPage = (value) => {
		if (value?.length <= 0) {
			const q = deleteParam("rows");
			setRowsPerPage(10);
			return push(`${pathname}?${q}`);
		}
		const q = setParam("rows", value);
		push(`${pathname}?${q}`);
	};

	const changeFirstPage = (value) => {
		if (value?.length <= 0) {
			const q = deleteParam("first_page");
			setFirstPage(0);
			return push(`${pathname}?${q}`);
		}
		const q = setParam("first_page", value);
		push(`${pathname}?${q}`);
	};

	const changeSearchTerm = (value) => {
		if (value?.length <= 0) {
			const q = deleteParam("search");
			setSearchTerm("");
			return push(`${pathname}?${q}`);
		}
		const q = setParam("search", value);
		push(`${pathname}?${q}`);
	};

	return {
		firstPage,
		rowsPerPage,
		page,
		searchTerm,
		changePage,
		changeRowsPerPage,
		changeFirstPage,
		changeSearchTerm,
	};
};

export default useInstitutionsFilters;
